import { SimpleTransferOrderReceivingUpdatePage } from "@/features/simple-transfer-order-receiving/pages/SimpleTransferOrderReceivingUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/receiving/simple-transfer-order/$id/update",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_to_receiving.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderReceivingUpdatePage,
});
